export const STATE_NAME = "designee";
export const FORM_NAME = STATE_NAME;
export const HEADER_FORM_NAME = STATE_NAME + "header";
